export default __webpack_public_path__ + "static/media/logo.142f5a94.png";